<div class="quantity-container" tabindex="1" [formGroup]="formGroup" *ngIf="formGroup">
  <div class="selector minus" (click)="decrease()">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <path fill="#222" fill-rule="evenodd" d="M3.429 7.429H12.572000000000001V8.572000000000001H3.429z"/>
    </svg>
  </div>
  <div class="quantity">
    <label for="quantity"></label>
    <input class="select-input" id="quantity" type="number" min="1" [max]="maxValue" formControlName="{{ formControlName }}"
           [value]="actualValue" (change)="changed($event)"/>
  </div>
  <div class="selector plus" (click)="increase()">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <path fill="#222" fill-rule="evenodd" d="M12.571 7.429L8.571 7.429 8.571 3.429 7.429 3.429 7.429 7.429 3.429 7.429 3.429 8.571 7.429 8.571 7.429 12.571 8.571 12.571 8.571 8.571 12.571 8.571z"/>
    </svg>
  </div>
</div>
